// Separate file to make testing easier
export async function dynamicImportAgent(apiKey: string) {
  // Create a dynamic import function that won't be analyzed by Webpack
  const importFn = new Function('url', 'return import(url)');

  const FingerprintJS = await importFn(`https://fp.coinbase.com/web/v3/${apiKey}`);
  return FingerprintJS.load({
    endpoint: 'https://fp.coinbase.com',
    scriptUrlPattern: 'https://fp.coinbase.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
  });
}
